import ThemedComponent from '../../hoc/ThemedComponent';
import FinancesPage from './FinancesPage';
import { default as FinancesPage3 } from '../../themes/3/pages/finances/FinancesPage';
import { default as FinancesPage4 } from '../../themes/4/pages/finances/FinancesPage';

const ThemedFinancesPages = {
    default: FinancesPage,
    // 3: FinancesPage3,
    // 4: FinancesPage4,
};

export const ThemedFinancesPage = ThemedComponent(ThemedFinancesPages);